import { render, staticRenderFns } from "./EditItemPage.vue?vue&type=template&id=62bf8730&scoped=true&"
import script from "./EditItemPage.vue?vue&type=script&lang=js&"
export * from "./EditItemPage.vue?vue&type=script&lang=js&"
import style0 from "./EditItemPage.vue?vue&type=style&index=0&id=62bf8730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf8730",
  null
  
)

export default component.exports